module.exports = __webpack_public_path__ + "img/feature-ico-1.92105a94.svg";